import { useState } from "react"
import api from "../api"
import Swal from "sweetalert2"

function Login({ setToken }) {
  const [password, setPassword] = useState("")

  const handleLogin = async (e) => {
    e.preventDefault()
    try {
      const res = await api.post("/auth/verificar", { password })
      if (res.data.autorizado && res.data.token) {
        localStorage.setItem("token", res.data.token)
        setToken(res.data.token)
        Swal.fire({ icon: "success", title: "Bienvenido", timer: 1500, showConfirmButton: false })
      } else {
        Swal.fire({ icon: "error", title: "Contraseña incorrecta" })
      }
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error", text: err.response?.data?.error || "Error al conectar" })
    }
  }

  return (
    <div className="login-container">
      <div className="login-box card">
        <h2>Acceso al Sistema</h2>
        <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <input 
            type="password" 
            placeholder="Ingrese su contraseña" 
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
          />
          <button type="submit" className="btn-primary">Entrar</button>
        </form>
      </div>
    </div>
  )
}

export default Login
